import { Component, OnInit } from '@angular/core';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { StaticPageUpdateDto } from 'src/app/shared/dtos/staticPage/staticPageUpdateDto';
import { PageType } from 'src/app/shared/enums/pageType';
import { StaticPageService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  constructor(private staticPageService: StaticPageService,
    private loadingService: LoadingService,
    private notificationService: NotificationService
  ) {
  }



  staticPageUpdateDto: StaticPageUpdateDto = this.emptyModel()
  popupVisible: boolean = false;
  toolbarButtonOptions: DxButtonTypes.Properties = {
    text: 'Ön İzleme',
    stylingMode: 'text',
    onClick: () => this.popupVisible = true,
  };

  ngOnInit(): void {
    this.staticPageService.getByPageType(PageType.About).subscribe(data => {
      this.definationModel(data[0])
    })

  }


  async save() {
    this.loadingService.show()
    if (this.staticPageUpdateDto.id > 0) {
      await firstValueFrom(this.staticPageService.update(this.staticPageUpdateDto.id, this.staticPageUpdateDto))
    } else {
      await firstValueFrom(this.staticPageService.create(this.staticPageUpdateDto))
    }
    this.notificationService.show('İşleminiz tamamlandı.')
    this.loadingService.hide()
  }

  definationModel(data: any) {
    this.staticPageUpdateDto.id = data.id
    this.staticPageUpdateDto.title = data.title
    this.staticPageUpdateDto.content = data.content
    this.staticPageUpdateDto.tag = data.tag
    this.staticPageUpdateDto.imageUrl = data.imageUrl
    this.staticPageUpdateDto.pageType = PageType.About
    this.staticPageUpdateDto.metaKeyword = data.metaKeyword
    this.staticPageUpdateDto.metaDescription = data.metaDescription
  }

  emptyModel() {
    return {
      id: 0,
      title: '',
      content: '',
      tag: '',
      imageUrl: '',
      pageType: PageType.About,
      metaKeyword: '',
      metaDescription: ''
    }
  }

  onFileSelected(base64: any) {
    this.staticPageUpdateDto.selectedFileBase64 = base64
  }

}
